import styled from 'styled-components'
import { colors } from '../../theme'

export const PrincipalDiv = styled.div`
  margin-top: 20px;
  background-color: ${colors.surface};
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.28);
  border-radius: 24px;
  padding: 20px;

  h3 {
    font-size: 16px;
  }
`

export const Acessos = styled.div`
  margin-top: 30px;
  position: relative;
  padding: 5px 30px 5px 0px;
  width: 100%;
  text-align: left;

  label {
    position: absolute;
    top: -4px;
    left: 15px;
    background: ${colors.surface};
    color: ${colors.grey500};
    padding: 0 3px;
    font-size: 12px;
  }

  select {
    width: 320px;
    height: 23px;
    border: 1px solid ${colors.grey300};
    border-radius: 12px;
    font-size: 14px;
    padding: 20px 20px 20px 20px;
  }
  option {
    font-size: 14px;
    font-weight: 600;
  }
`

export const DivForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  align-items: center;
  margin-top: 25px;
`
export const DivAccess = styled.div`
  margin: 30px 0;
  display: flex;
  gap: 20px;
  flex-direction: column;
  width: 25%;
  position: relative;
`

export const DivAccessEstados = styled.div`
  margin-top: 30px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  width: 100%;
  position: relative;
`

export const SpanAdm = styled.span`
  margin: 10px 0 25px 0;
  display: flex;
  font-size: 14px;
  b {
    margin-top: 2px;
  }
`

export const DivAdm = styled.div`
  margin-top: 30px;
  width: 25%;
`
export const Byes = styled.b`
  margin-right: 35px;
  margin-top: 2px;
`
export const B = styled.b`
  margin-left: 25px;
  font-weight: 600;
  font-size: 14px;
`

export const FormLogin = styled.div`
  position: relative;
`

export const LabelLSwitch = styled.label`
  position: absolute;
  top: -13px;
  background: ${colors.surface};
  color: ${colors.grey500};
  left: 0px;
  padding: 0 3px;
  font-size: 12px;
`

export const LabelLogin = styled.label`
  position: absolute;
  top: -9px;
  background: ${colors.surface};
  color: ${colors.grey500};
  left: 15px;
  padding: 0 3px;
  font-size: 12px;
`
export const LabelCheck = styled.label`
  background: ${colors.surface};
  color: ${colors.grey500};
  font-size: 12px;
`

export const SpanCheck = styled.span`
  display: flex;
  gap: 5px;
`

export const InputLogin = styled.input`
  /* Transparente de proposito: o rotulo flutuante recorta a borda deste campo, e
     esse recorte so funciona se campo e container tiverem a MESMA cor. Com o campo
     preenchido, o rotulo atravessa a fronteira e vira uma caixa visivel. Campos SEM
     rotulo flutuante (busca, filtros) seguem preenchidos pela base do GlobalStyle. */
  background-color: transparent;
  width: 320px;
  height: 23px;
  border: 1px solid ${colors.grey300};
  border-radius: 12px;
  font-size: 14px;
  padding: 20px 20px 20px 20px;
`

export const BtnSave = styled.button`
  margin: 30px 0;
  cursor: pointer;
  background-color: ${colors.accentBg};
  color: ${colors.white};
  border: none;
  width: 240px;
  height: 40px;
  border-radius: 16px;
`
export const Search = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`
export const InputStyle = styled(InputLogin)<{
  border: string
  sizeY: string
  sizeX: string
}>`
  border: 1.5px solid ${({ border }) => border};
  border-radius: 12px;
  width: ${({ sizeX }) => sizeX};
  height: ${({ sizeY }) => sizeY};
  font-size: 12px;
`
export const ButtonNewUser = styled.button`
  width: 160px;
  height: 40px;
  background-color: ${colors.accentBg};
  text-decoration: none;
  color: ${colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  font-size: 12px;
  cursor: pointer;
  border: none;

  h3 {
    font-weight: 500;
  }
`
export const Span = styled.button`
  position: absolute;
  top: 54px;
  left: 230px;
  border: none;
  background-color: transparent;
  cursor: pointer;
`
export const Filtro = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  width: 400px;
`

export const FilterSalesPeople = styled.div`
  display: flex;
  flex-direction: column;
  height: 50px;
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: 350px;
  z-index: 10;
`
export const Estados = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  margin: 20px 0;
  gap: 20px;
`
